import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bold-arrow--sprite",
  "use": "bold-arrow--sprite-usage",
  "viewBox": "0 0 22 19",
  "content": "<symbol viewBox=\"0 0 22 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bold-arrow--sprite\">\n<path d=\"M15.3333 0.166748H9.33333L16 9.50008L9.33333 18.8334H15.3333L22 9.50008L15.3333 0.166748Z\" />\n<path d=\"M6 0.166748H0L6.66667 9.50008L0 18.8334H6L12.6667 9.50008L6 0.166748Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol